export enum ActivityStateEnum {
  pending = 1,
  in_progress,
  completed,
  out_of_time,
}
